import { head } from 'ramda';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { TextButton } from '../../../components/common';
import { MainSource } from '../../../constants/Source';
import { RouteBuilder } from '../../../utils/RouteHelpers';
import { Truncated } from './components';
import { GenericNotification } from './GenericNotification';

export const removedFromBoardNotification =
  ({ board, items }) =>
  ({ notification }) =>
    (
      <GenericNotification
        notification={notification}
        dataHook="items-removed-from-board-notification"
        text={
          <FormattedMessage
            id="boards.context-menu.delete-items.notification"
            values={{
              boardsCount: items.length,
              itemName: <Truncated>{head(items).name}</Truncated>,
              boardLink: (
                <TextButton
                  as={Link}
                  size="small"
                  to={RouteBuilder.Source(MainSource.Boards, board.id)}
                  underline="always"
                  skin="dark"
                  dataHook="notification-link"
                >
                  {board.name}
                </TextButton>
              ),
            }}
          />
        }
      />
    );
